var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12z",
    fill: "#4EAF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.255 18v-4.672c2.85-.157 4.995-.84 4.995-1.657 0-.817-2.145-1.5-4.995-1.657V8.711h3.559V6H7.083v2.711h3.558v1.31c-2.798.168-4.891.843-4.891 1.65 0 .808 2.093 1.483 4.891 1.651V18h2.614zm0-6.104V10.31c2.454.113 4.284.549 4.284 1.07 0 .606-2.48 1.097-5.539 1.097-3.06 0-5.54-.491-5.54-1.098 0-.513 1.78-.944 4.181-1.064v1.575a23.631 23.631 0 0 0 2.614.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#000",
    d: "M-2 14h29v7H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.017 17.046h.224v-1.137h-.224v-.227H6.672v1.59h1.345v-.226zm.896-1.364v1.59h-.224v.228h-.224v.227H8.24v.227H6.672V20H6v-5h2.24v.227h.225v.227h.224v.228h.224zM11.379 18.864h.224v-2.728h-.224v-.227h-.224v-.227h-.672v.227h-.224v.227h-.224v2.728h.224v.227h.224v.227h.672v-.227h.224v-.227zm.896-2.955v3.182h-.224v.227h-.224v.227h-.224v.228h-.224V20h-1.12v-.227h-.224v-.227H9.81v-.228h-.225v-.227h-.224v-3.182h.224v-.227h.225v-.228h.224v-.227h.224V15h1.12v.227h.224v.227h.224v.228h.224v.227h.224zM15.638 19.318V20h-2.913v-5h.672v4.318h2.24zM19 15v.682h-.224v.454h-.224v.455h-.224v.454h-.224v.455h-.224V20h-.672v-2.5h-.225v-.454h-.224v-.455h-.224v-.455h-.224v-.454h-.224V15h.672v.454h.224v.455h.224v.455h.225v.454h.224v-.454h.224v-.455h.224v-.455h.224V15H19z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtPoly);
export default __webpack_public_path__ + "static/media/USDT-POLY.23c65668461d46cafec4bfd4f1057420.svg";
export { ForwardRef as ReactComponent };